import api from "./apiServices"; // Your existing configured axios instance

// Fetch category groups
export const listCategoryGroups = (params) => {
  // params: { skip, limit, purpose, is_active, include_children }
  return api.get("/admin/category-groups/", { params });
};

// Create a category group
export const createCategoryGroup = (groupData, locale) => {
  return api.post("/admin/category-groups/", groupData, {
    params: { locale: locale },
  });
};

// Get a single category group by ID
export const getCategoryGroupById = (groupId, include_children = false, locale) => {
  return api.get(`/admin/category-groups/${groupId}`, {
    params: { include_children, locale: locale},
  });
};

// Update a category group
export const updateCategoryGroup = (groupId, groupData, locale) => {
  return api.put(`/admin/category-groups/${groupId}`, groupData, {
    params: { locale: locale },
  });
};

// Soft delete a category group (sets is_active=false)
export const deleteCategoryGroup = (groupId, locale) => {
  return api.delete(`/admin/category-groups/${groupId}`, {
    params: { locale: locale },
  });
};

// Hard delete a category group (NEEDS A NEW BACKEND ENDPOINT, e.g., /category-groups/{group_id}/hard)
export const hardDeleteCategoryGroup = (groupId, locale) => {
  // Assuming you create a new endpoint like '/category-groups/{group_id}/force-delete'
  // For now, this is a placeholder:
  return api.delete(`/admin/category-groups/${groupId}/hard`, {
    params: { locale: locale },
  }); // Replace with actual hard delete endpoint
  // If your backend's DELETE /category-groups/{group_id} can take a query param for hard delete, adjust accordingly.
};

// Add a child category to a group
export const addChildToGroup = (groupId, childCategoryId, locale) => {
  return api.post(`/admin/category-groups/${groupId}/children`, {
    child_category_id: childCategoryId,
  }, {
    params: { locale: locale },
  });
};

// Remove a child category from a group
export const removeChildFromGroup = (groupId, childCategoryId, locale) => {
  return api.delete(`/admin/category-groups/${groupId}/children/${childCategoryId}`, {
    params: { locale: locale },
  });
};

// Fetch all categories (useful for searching child categories to add to a group)
// You likely have this already from your CategoryManagement section.
// If not, a simplified version:
export const listAllCategoriesForSelect = (params) => {
    console.log("Fetching categories with params");
  // e.g., params for type=child
  return api.get("/admin/categories/list", { params }); // Adjust endpoint if needed
};
